import React from 'react';
const stats = [['1500+', 'Insegnanti di Pilates in tutta Italia'], ['6 + 5', 'Volumi e bonus esclusivi'], ['4.9/5', 'Valutazione media delle professioniste'], ['Ogni giorno', 'Per elevare lo standard dello Studio']];
const notes = [['“Ho pianificato l’intero anno di Pilates in una sola sera. Ora ogni lezione ha un obiettivo chiaro e le mie allieve non vedono l’ora di tornare sul Reformer.”', 'Martina R.', 'Istruttrice di Pilates · Milano'], ['“Le mie allieve migliorano più velocemente perché seguono finalmente una progressione logica. Ha cambiato il mio modo di insegnare Pilates.”', 'Elena B.', 'Studio Owner Pilates · Roma']];
export function ProofSection() {
  return <section className="bg-[#241622] px-5 pb-16" data-id="element-192" data-mp="3nq3crhtg5h8r">
      <div className="mx-auto max-w-6xl" data-id="element-193" data-mp="3sqraemc6kwby">
        <div className="grid grid-cols-2 border border-emerald-300/25 bg-[#38233c] sm:grid-cols-4" data-id="element-194" data-mp="3srskooldhesm">
          {stats.map(([value, label]) => <div key={label} className="border-b border-r border-emerald-300/15 px-4 py-6 text-center last:border-r-0 sm:border-b-0" data-id="element-195" data-mp="15ni2nruo0pob">
              <p className="font-display text-4xl font-bold uppercase text-emerald-300 sm:text-5xl" data-id="element-196" data-mp="10n3w6e8ppnse">
                {value}
              </p>
              <p className="mt-1 text-[10px] font-bold uppercase tracking-widest text-slate-300" data-id="element-197" data-mp="ro8mutadfxkv">
                {label}
              </p>
            </div>)}
        </div>
        <div className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-198" data-mp="1jewkhvcu6kts">
          {notes.map(([quote, name, role]) => <figure key={name} className="flex flex-col border border-emerald-950/10 bg-white p-6" data-id="element-199" data-mp="1eny5cz3l3ss4">
              <div className="mb-4 text-amber-500" aria-label="5 stelle su 5" data-id="element-200" data-mp="1alt9rutksm2u">
                ★★★★★
              </div>
              <blockquote className="flex-1 text-sm font-medium italic leading-relaxed text-[#09281d]" data-id="element-201" data-mp="276lklxvwgdla">
                {quote}
              </blockquote>
              <figcaption className="mt-5 border-t border-emerald-950/10 pt-4 text-sm font-bold text-[#09281d]" data-id="element-202" data-mp="fyq3gamzx6k">
                {name}
                <span className="ml-2 text-xs font-medium text-slate-600" data-id="element-203" data-mp="5ejpxelz8euh">
                  {role}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}